import { flow } from "fp";

import * as Data from "~/Data";
import { Company } from "~/Company";
import * as Driver from "~/Driver";
import { Request } from "~/Request";
import { DriverId } from "./DriverId";

export namespace Get {
    /** [API Documentation](http://equipmentshare.pages.internal.equipmentshare.com/equipmentshare-api/develop/index.html?highlight=drivers#get--companies-(int-company_id)-drivers) */
    export const request = (
      { company }: Company,
      driverId: DriverId
    ): Data.Cache.Request<Driver.Driver> => {
  
      return flow(
        Request.fromConfig({
          endpoint: `/companies/${company.id}/drivers/` + String(driverId),
        }),
        Request.Expect.status(200),
        Request.Expect.json(Driver.Response.runtime()),
        Request.onSuccess(
          Data.Cache.fromIndividual((response) => 
          [
              `${response.driver_id}`,
              Driver.Response.decode(response),
          ]
          )
        )
      );
    };
  }